module.exports = __webpack_public_path__ + "img/列表.1448bb48.png";